<div class="login-container">
  <div [ngClass]="getLoginImageClass()"></div>
  <div class="login-form-section">
    <div class="page-title-section">
      <div class="site-name-text-section">
        {{ headerProjectName }} {{ environment }} Server
      </div>
    </div>
    @if (!isForgotPassword) {
      <form [formGroup]="loginForm" class="login-form">
        <div class="card-block">
          <div class="form-header">
            <h3 class="welcome-text">Welcome Back !</h3>
          </div>

          <div class="form-group">
            <label for="email" class="form-label">Your Email Address</label>
            <mat-form-field appearance="outline">
              <mat-label>Your Email Address</mat-label>
              <mat-icon matPrefix>person</mat-icon>
              <input
                matInput
                id="email"
                type="email"
                placeholder="Your Email Address"
                formControlName="email"
                required
              />
              @if (
                loginForm.controls['email'].touched &&
                loginForm.controls['email'].errors?.['requiredAndNoEmptySpaces']
              ) {
                <mat-error>
                  {{
                    loginForm.controls['email'].errors?.[
                      'requiredAndNoEmptySpaces'
                    ]
                  }}
                </mat-error>
              }
              @if (
                loginForm.controls['email'].touched &&
                loginForm.controls['email'].errors?.['validEmail']
              ) {
                <mat-error>
                  {{ loginForm.controls['email'].errors?.['validEmail'] }}
                </mat-error>
              }
            </mat-form-field>
          </div>

          <div class="form-group">
            <label for="password" class="form-label">Password</label>
            <mat-form-field appearance="outline">
              <mat-label>Password</mat-label>
              <mat-icon matPrefix>lock</mat-icon>
              <input
                matInput
                id="password"
                [type]="fieldTextType ? 'text' : 'password'"
                formControlName="password"
                placeholder="Password"
                required
              />
              <mat-icon matSuffix (click)="toggleFieldTextType()">{{
                fieldTextType ? 'visibility_off' : 'visibility'
              }}</mat-icon>
              @if (
                loginForm.controls['password'].touched &&
                loginForm.controls['password'].errors?.[
                  'requiredAndNoEmptySpaces'
                ]
              ) {
                <mat-error> This field is required. </mat-error>
              }
              @if (
                loginForm.controls['password'].touched &&
                loginForm.controls['password'].errors?.['minLengthRequired']
              ) {
                <mat-error>
                  {{
                    loginForm.controls['password'].errors?.['minLengthRequired']
                  }}
                </mat-error>
              }
            </mat-form-field>
          </div>

          <div class="form-footer">
            <a
              class="forgot-password"
              (click)="toggleForm()"
              tabindex="0"
              (keydown.enter)="toggleForm()"
              >Forgot Password?</a
            >
          </div>

          <div class="form-group">
            <button type="button" (click)="onLogin()" class="submit-button">
              Sign in
            </button>
          </div>
        </div>
      </form>
    } @else if (isForgotPassword) {
      <form [formGroup]="forgotPasswordForm" class="login-form">
        <div class="card-block">
          <div class="form-header">
            <h3 class="welcome-text">Reset Password !</h3>
          </div>

          <div class="form-group">
            <label for="" class="form-label">Your Email Address</label>
            <mat-form-field appearance="outline">
              <mat-label>Your Email Address</mat-label>
              <mat-icon matPrefix>person</mat-icon>
              <input
                matInput
                id="email"
                type="email"
                placeholder="Your Email Address"
                formControlName="email"
                required
              />
              @if (
                forgotPasswordForm.controls['email'].touched &&
                forgotPasswordForm.controls['email'].errors?.[
                  'requiredAndNoEmptySpaces'
                ]
              ) {
                <mat-error>
                  {{
                    forgotPasswordForm.controls['email'].errors?.[
                      'requiredAndNoEmptySpaces'
                    ]
                  }}
                </mat-error>
              }
              @if (
                forgotPasswordForm.controls['email'].touched &&
                forgotPasswordForm.controls['email'].errors?.['validEmail']
              ) {
                <mat-error>
                  {{
                    forgotPasswordForm.controls['email'].errors?.['validEmail']
                  }}
                </mat-error>
              }
            </mat-form-field>
          </div>

          <div class="form-footer">
            <a
              class="forgot-password"
              (click)="toggleForm()"
              tabindex="0"
              (keydown.enter)="toggleForm()"
              >Back To Login Page</a
            >
          </div>

          <div class="form-group">
            <button
              type="button"
              (click)="onForgotPassword()"
              class="submit-button"
            >
              Reset Password
            </button>
          </div>
        </div>
      </form>
    }
  </div>
</div>
